import { t } from '@lingui/macro';
import { Api } from 'api';
import { FormControlFormSelect, FormControlFormSelectProps } from 'core';
import React, { useMemo } from 'react';
import { useQuery } from 'react-query';
import { ExpertisePackageGroup, ExpertiseQueryCacheKey } from 'types';

export interface ExpertisePackageGroupProps extends FormControlFormSelectProps {
  onPackageGroupChange?: (selectedGroup: ExpertisePackageGroup) => void;
}
export const ExpertisePackageGroupSelect: React.FC<ExpertisePackageGroupProps> = ({
  onPackageGroupChange,
  ...formSelectProps
}) => {
  const query = useQuery(
    ExpertiseQueryCacheKey.GetAllPackageGroups,
    async () => {
      const response = await Api.Expertise.getAllPackageGroups();
      return response.data;
    },
    {
      refetchOnWindowFocus: false,
      cacheTime: 0,
    },
  );

  const filteredData = useMemo(() => {
    if (!query.data) return [];

    try {
      const authUserInfo = localStorage.getItem('authUserInfo');
      if (!authUserInfo) return query.data;

      const userInfo = JSON.parse(authUserInfo);
      const userGroupType = userInfo?.expertisePoint?.groupType;

      if (!userGroupType) return query.data;

      return query.data.filter((group) => {
        if (!group.brands || group.brands.length === 0) return false;
        return group.brands.includes(userGroupType);
      });
    } catch (error) {
      return query.data;
    }
  }, [query.data]);

  const handleChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const selectedGroup = filteredData.find((group) => group.id === Number(e.target.value));
    if (selectedGroup && onPackageGroupChange) {
      onPackageGroupChange(selectedGroup);
    }
    if (formSelectProps.onChange) {
      formSelectProps.onChange(e);
    }
  };
  return (
    <FormControlFormSelect label={t`Liste Seç`} placeholder={t`Liste Seç`} {...formSelectProps} onChange={handleChange}>
      {filteredData.map((expertisePackageGroup) => (
        <option value={expertisePackageGroup.id} key={`exps${expertisePackageGroup.id}`}>
          {expertisePackageGroup.name}
        </option>
      ))}
    </FormControlFormSelect>
  );
};
